'use strict';

frontendApp.directive('iioNotification', ['$rootScope', '$timeout', 'NotificationService', function($rootScope, $timeout, NotificationService) {

    return {
        restrict:'E',
        templateUrl: 'partials/notification.html',
        scope: {
            message: '=',
            index: '='
        },
        link: function(scope, element, attrs) {

            // With replace:true gone, element is the <iio-notification> wrapper.
            // The CSS transition classes (.iio-notification-open / .iio-notification-close)
            // must be applied to the inner .iio-notification element where the styles live.
            var notification = element.find('.iio-notification');

            $timeout(function() {
                notification.removeClass('iio-notification-open');
            }, 150);

            scope.dismiss = function() {
                notification.addClass('iio-notification-close');
                $timeout(function() {
                    NotificationService.dismiss(scope.index);
                }, 150);
            };

            if (scope.message.timeout && scope.message.timeout > 0) {
                $timeout(function() {
                    scope.dismiss();
                }, scope.message.timeout);
            }

            // Listen for dismiss events
            scope.$on(NotificationService.EVENTS.DISMISS_ALL, function(event) {
                scope.dismiss();
            });
        }
    }
}]);
